export enum GoogleDriveServiceError {
  OperationRequiresCachedToken = 'google-drive-service/operation-requires-cached-token',
}
